module.exports = __webpack_public_path__ + "img/logo.a00ab7e7.png";